import { isTauri, tauriInvoke } from "../utils/tauri";
import api from "./api";

export async function getDeviceSettings(keys: string[]) {
  console.log("getDeviceSettings", keys);
  if (!isTauri()) {
    // web/dev fallback iz localStorage-a
    const out: Record<string, any> = {};
    for (const k of keys) {
      const raw =
        localStorage.getItem(k) ?? localStorage.getItem("device." + k);
      if (raw == null) {
        out[k] = null;
      } else {
        try {
          out[k] = JSON.parse(raw);
        } catch {
          out[k] = raw;
        }
      }
    }
    console.log("getDeviceSettings (fallback)", out);
    return out;
  }

  return tauriInvoke<Record<string, any>>("get_device_settings", { keys });
}

function sanitizeValue(v: any) {
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v;
  if (v == null) return null;
  return String(v);
}

export async function setDeviceSettingsBulk(map: Record<string, any>) {
  const pairs = Object.entries(map).map(([key, value]) => ({
    key,
    value: sanitizeValue(value),
  }));

  if (isTauri()) {
    await tauriInvoke("set_device_settings_bulk", { pairs });
  } else {
    // web/dev fallback – snimi i u "device." prefiks
    for (const [k, v] of Object.entries(map)) {
      const vs =
        typeof v === "string" ? v : JSON.stringify(sanitizeValue(v));
      localStorage.setItem(k, vs);
      localStorage.setItem("device." + k, vs);
    }
  }
}

/** SERVER SYNC **/

export async function pullFromServer(keys: string[]) {
  // BE: GET /api/pos1/device-settings?keys=a,b,c  ->  { key:value }
  const q = keys.join(",");
  const { data } = await api.get(`/pos/device-settings`, { params: { keys: q } });
  const obj: Record<string, any> = data || {};
  // mirror u lokalno
  await setDeviceSettingsBulk(obj);
  return obj;
}

export async function pushToServer(pairs: Array<{ key: string; value: any }>) {
  // BE ima samo setKey, pa idemo jedan po jedan
  for (const { key, value } of pairs) {
    await api.post(`/pos/device-settings`, { key, value: sanitizeValue(value) });
  }
}
